import { Box } from '@mui/material';
import React from 'react';
export const ToolbarButton = (props) => {
    return (React.createElement(Box, { onClick: props.onClick, sx: {
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: props.size,
            height: props.size,
            '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
            },
        } }, props.children));
};
